<div class="h-screen flex bg-[#f8f9fb] dark:bg-[#0b0f19] font-sans overflow-hidden text-slate-800 dark:text-slate-200">
  <!-- Mobile Overlay Backdrop -->
  @if (mobileOpen) {
  <div class="fixed inset-0 z-30 bg-slate-900/50 backdrop-blur-xs md:hidden" (click)="closeMobile()"></div>
  }

  <!-- Sidebar Navigation Panel -->
  <app-sidebar [isCollapsed]="isSidebarCollapsed" [mobileOpen]="mobileOpen" (closeMobile)="closeMobile()"></app-sidebar>

  <!-- Right Hand Primary Content Block -->
  <div class="flex-1 flex flex-col h-screen min-w-0 overflow-hidden relative">
    <!-- Header/Topbar -->
    <app-topbar [isSidebarCollapsed]="isSidebarCollapsed" [mobileOpen]="mobileOpen" (toggleSidebar)="toggleSidebar()"
      (toggleMobile)="toggleMobile()"></app-topbar>

    <!-- Scrollable Router Body -->
    <main class="flex-1 overflow-y-auto">
      <div class="p-4 sm:p-5 md:p-6 max-w-7xl w-full mx-auto min-h-full flex flex-col">
        <router-outlet></router-outlet>
      </div>
    </main>

    <!-- App Footer -->
    <app-footer></app-footer>
  </div>
</div>
<app-idle-timeout-dialog></app-idle-timeout-dialog>